import { Link } from 'react-router-dom';
import type { Chapter } from '../types';

export function Home({ chapters }: { chapters: Chapter[] }) {
  return (
    <div>
      <h2>CIS5300 — NLP Learning Notes</h2>
      <p className="muted">
        Reading materials, chapter notes, assignments, and a growing cheatsheet.
        Click any chapter on the left to dive in.
      </p>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(260px,1fr))', gap: 12 }}>
        {chapters.map((c) => (
          <Link key={c.id} to={`/chapter/${c.id}`} className="card" style={{ display: 'block' }}>
            <div className="muted">Chapter {c.number}</div>
            <h3 style={{ margin: '4px 0 8px' }}>{c.title}</h3>
            <div className="muted" style={{ fontSize: 13 }}>
              {c.summary ?? 'No summary yet.'}
            </div>
          </Link>
        ))}
      </div>

      {!chapters.length && (
        <div className="card">
          <p>No chapters yet. Run <code>npm run db:seed:remote</code> after creating the D1 DB, or add one in the Admin tab.</p>
        </div>
      )}
    </div>
  );
}
